import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';

import { FLASH_TYPES } from '../../constants/flashTypes';

const Flash = (props) => {
  const { response, type } = props;
  const [isVisible, setIsVisible] = useState(false);

  const showFlash = () => {
    setIsVisible(true);

    setTimeout(() => {
      setIsVisible(false);
    }, 10000);
  };

  useEffect(() => {
    if (!isEmpty(response)) {
      return showFlash();
    }
    return () => {
      setIsVisible(false);
    };
  }, [response]);

  const responseKeys = Object.keys(response);

  if (isVisible) {
    return responseKeys.map((key) => {
      return (
        <div key={key} className={`flash-${type}`}>
          {response[key]}
        </div>
      );
    });
  }

  return null;
};

Flash.propTypes = {
  response: PropTypes.shape().isRequired,
  type: PropTypes.string,
};

Flash.defaultProps = {
  type: FLASH_TYPES.error,
};

export default Flash;
